<template>
  <div class="BSCSelect" :class="{ 'BSCSelect--is-open': isOpen }">
    <div @click="handleButtonClick" class="BSCSelect--container">
      {{ displayedValue }}

      <div class="BSCSelect-icon">
        <BSCIcon icon="arrow" :size="14" />
      </div>
    </div>

    <div
      class="BSCSelect-content"
      ref="selectContent"
      :class="{ 'BSCSelect-content--is-open': isOpen }"
    >
      <div
        v-for="(option, index) in options"
        ref="selectItem"
        @click="updateActiveItem(option.id)"
        :key="index"
        class="BSCSelect-content-item"
        :class="{
          'BSCSelect-content-item--selected': activeItemName.id === option.id
        }"
      >
        {{ option.value }}
      </div>
    </div>
    <div class="BSCSelect--wrapper" v-if="isOpen" @click="isOpen = false"></div>
  </div>
</template>

<script>
'use strict'

export default {
  name: 'BSCSelect',
  emits: ['on-select'],
  props: {
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'normal'
    },
    selectedItemId: {
      type: Number
    }
  },
  data() {
    return {
      isOpen: false,
      itemActiveId: null,
      isPlaceholderDisplayed: true
    }
  },
  computed: {
    activeItemName() {
      let item = this.options.find(item => item.id === this.itemActiveId)

      return item ? item : '' //if item === undefined (on the first render), return '' to avoid unexpected error
    },
    displayedValue() {
      return this.isPlaceholderDisplayed
        ? this.placeholder
        : this.activeItemName.value
    }
  },
  methods: {
    handleButtonClick() {
      this.isOpen = !this.isOpen
    },
    updateActiveItem(itemId) {
      this.itemActiveId = itemId
      this.isPlaceholderDisplayed = false
      this.isOpen = false

      this.$emit('on-select', itemId)
    },
    calcContentHeight() {
      //Calculate the content height to set the max-height property. In order to had a dymnamic max-height transition
      let total = 0

      if (this.isOpen)
        //if open (calculate max height) else max-height = 0
        this.$refs.selectItem.forEach(item => (total += item.offsetHeight + 20)) // item offset height + margin 20px

      // total += this.size + 20

      if (this.isOverflowBottom(this.$refs.selectContent, total)) {
        this.$refs.selectContent.style.bottom = '120%'
        this.$refs.selectContent.style.top = 'unset'
      }

      // this.$refs.selectContent.style.maxHeight =
      //   this.size > 0 ? this.size : total
      this.$refs.selectContent.style.maxHeight = total + 'px'
    },
    isOverflowRight(element, hiddenWidth = 0) {
      return (
        element.getBoundingClientRect().right + hiddenWidth > window.innerWidth
      )
    },
    isOverflowBottom(element, hiddenHeight = 0) {
      //The height is hidden by default (due to the animation max height = 0)
      return (
        element.getBoundingClientRect().bottom + hiddenHeight >
        window.innerHeight
      )
    }
  },
  watch: {
    isOpen: {
      immediate: false,
      handler() {
        this.calcContentHeight()
        if (this.isOverflowRight(this.$refs.selectContent)) {
          this.$refs.selectContent.style.right = 0
        }
      }
    }
  },
  mounted() {
    this.isPlaceholderDisplayed = this.placeholder ? true : false

    if (this.placeholder && !this.selectedItemId)
      this.isPlaceholderDisplayed = true
    else {
      this.itemActiveId = this.selectedItemId
        ? this.selectedItemId
        : this.options[0].id
      this.isPlaceholderDisplayed = false
    }

    this.calcContentHeight()
  }
}
</script>
